import { render, staticRenderFns } from "./PrevNextStepper.vue?vue&type=template&id=56dbfede&lang=pug"
import script from "./PrevNextStepper.vue?vue&type=script&lang=js"
export * from "./PrevNextStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports